import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/configuration/filter'; // Importing Filter component
import Settings from 'views/partner/configuration/settings'; // Importing Settings component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Partner Settings View.
 * @extends JetView
 */
export default class PartnerSettingsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive cell behavior
            css: 'cajeros', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply theme to toolbar
                    elements: [
                        { view: 'label', label: _('Partner') }, // Label for the toolbar
                        {
                            type: 'wide', // Type of the element
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Icon width
                                    height: 30, // Icon height
                                    click: () => this.show('/top/dashboard'), // Click event to navigate
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including Filter component
                Settings, // Including Settings component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            view: 'form', // Form component
            type: 'wide', // Type of the form
            responsive: true, // Enable responsive behavior
            scroll: true, // Enable scrolling
            rows: [left], // Rows configuration
        };
    }
}

// FILE DOCUMENTED
